<template>
  <div>Redirecting......</div>
</template>

<script>
export default {
  data() {
    return {
      parent: null,
    }
  },
  created() {
    this.parent = parent
    parent.location.href = 'http://localhost:8888'
  },
}
</script>
